import { IExpressionEvaluatorContext } from "@@expressions";
import { useEffect } from "react";
import { MaybePromise } from "../../ExpressionsModule/Models/MaybePromise";
import { IComponent } from "../Models/IComponent";
import { IViewController } from "../Models/IViewController";
import { ComponentService } from "../Services/ComponentService";

export default function useRegisterViewController<T extends IComponent>(
  component: T,
  context: IExpressionEvaluatorContext,
  refresh: (silentRefresh?: boolean) => MaybePromise
) {
  useEffect(() => {
    const componentService = context.GetProperty(ComponentService.KEY) as ComponentService;
    if (componentService) {
      const viewModelController: IViewController = {
        refresh: () => refresh(true),
      };
      componentService.register(component, viewModelController);
    }
  }, [refresh, component]);
}
